var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"}},[_c('path',{attrs:{"d":"M1.46446 8.53555L8.53553 1.46448M8.53553 8.53555L1.46446 1.46448","stroke":"#00FFF0","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }